import axios from "axios";
import { CompactEncrypt, importJWK } from 'jose';

export const getEnvironment = (env) => {
  switch (env) {
    case "e0":
    case "e1":
      return "development";
    case "e2":
      return "stage";
    case "e3_ipc1":
    case "e3_ipc2":
      return "production";
    default:
      return "development";
  }
}

export const encryptCscValue = async (csc, nodeEnv, key) => {
  key.key_ops = ["wrapKey", "encrypt"];
  const rsaKey = await importJWK(key, "RSA-OAEP-256")
  const encrypter = new CompactEncrypt(new TextEncoder().encode(csc))
      .setProtectedHeader({ alg: 'RSA-OAEP-256', enc: 'A256GCM', kid: key.kid});

  const encryptedData = await encrypter.encrypt(rsaKey)
  return encryptedData
};

export const followRedirect = (status, successRedirectUrl) => {
  if (successRedirectUrl !== null && successRedirectUrl !== "") {
    const redirectUrl = new URL(successRedirectUrl);
    const redirectParams = redirectUrl.searchParams;
    redirectParams.append("valid", status === "SUCCESS")
    window.location.href = redirectUrl.toString();
  }
}